/**
 * Helpers PURS des visites de prévention préparées pour le hors ligne
 * (aucun accès réseau ni stockage — testés unitairement).
 */
import { getApplicableGrilles } from './prevention';

/** Clé stable d'une ligne de « Visites à réaliser ». */
export const cleVisite = (v) => `${v.source}:${v.inspection_id || v.batiment_id}`;

/** Une visite est préparable si elle vise un bâtiment (les activités sans bâtiment ne le sont pas). */
export const estPreparable = (v) => !!v?.batiment_id;

const ajouterJours = (iso, jours) => {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + jours);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

/**
 * Sélection proposée par défaut : les visites en retard + celles dont l'échéance tombe
 * d'ici `jours` jours (aujourd'hui compris). Une visite sans date n'est pas cochée.
 */
export const selectionParDefaut = (visites, jours, aujourdhui) => {
  const limite = ajouterJours(aujourdhui, jours);
  return new Set(
    (visites || [])
      .filter((v) => estPreparable(v) && (v.statut === 'en_retard' || (v.date && v.date <= limite)))
      .map(cleVisite),
  );
};

/** Dernière inspection TERMINÉE par grille (sert au pré-remplissage, comme en ligne). */
export const derniereParGrille = (inspections) => {
  const parGrille = {};
  (inspections || [])
    .filter((i) => i.statut === 'terminee' && i.grille_inspection_id)
    .forEach((i) => {
      const actuelle = parGrille[i.grille_inspection_id];
      if (!actuelle || new Date(i.date_inspection) > new Date(actuelle.date_inspection)) {
        parGrille[i.grille_inspection_id] = i;
      }
    });
  return parGrille;
};

/**
 * Grilles proposées pour démarrer une visite hors ligne — même règle qu'en ligne :
 * pompier → uniquement les grilles applicables au bâtiment ; préventionniste / admin →
 * toutes les grilles, les applicables en premier.
 */
export const grillesPourVisite = (batiment, grilles, estPrevOuAdmin) => {
  const applicables = getApplicableGrilles(batiment, grilles);
  if (!estPrevOuAdmin) return applicables;
  const ids = new Set(applicables.map((g) => g.id));
  return [...applicables, ...(grilles || []).filter((g) => !ids.has(g.id))];
};

/** Même définition que dans Prévention (modal de choix de grille réservé à ces rôles). */
export const estPrevOuAdmin = (user) => {
  const role = (user?.role || '').toLowerCase();
  return !!user?.est_preventionniste
    || ['admin', 'superadmin', 'super_admin', 'superviseur'].includes(role);
};
